import { render, staticRenderFns } from "./MaintainContent.vue?vue&type=template&id=1bcdfd72&"
import script from "./MaintainContent.vue?vue&type=script&lang=js&"
export * from "./MaintainContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports